import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { BuildingsState } from './types';

export const getBuildingsState = (state: StoreState): BuildingsState =>
  state.buildings;

export const getBuildings = createSelector(
  getBuildingsState,
  state => state.buildingsById,
);
